// config.js
// Use environment variable for API URL, with fallback for local development
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:3001";
